import styles from './cart-item.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { useProject } from '../../project-hooks/useProject';
import { useEffect, useState } from 'react';
import ButtonText from '../../../components/button/button-text/ButtonText';
import { formatKrMoney } from '../../../utils';
import { ChangeCountButtons } from './ChangeCountButtons';
import { removeItemFromCart, updateItemInCart } from '../../../cart/cart-actions';
import useDebounce from '../../../components/hooks/debounce';
import { getRewardForItem } from '../../../cart/cart-selectors';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { getAvailableRewardCount } from '../../reward/reward-model';

export const CartItem = ({ item, max = 99 }) => {
    const project = useProject();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const query = queryString.parse(location.search);
    const subprojectId = query.subproject ? parseInt(query.subproject, 10) : undefined;
    const hideSupportButton = project?.profile?.hideSupportButton;
    const reward = useSelector((state) => getRewardForItem(state, project.id, item));
    const [localCount, setLocalCount] = useState(item.count);
    const debouncedCount = useDebounce(localCount, 400);
    const available = getAvailableRewardCount(reward);
    const maxCount = available ?? max;
    const showChangeCountButtons = !project?.profile?.hideChangeCountButtons;

    useEffect(() => {
        if (reward?.id) {
            dispatch(updateItemInCart({ projectId: project.id, rewardId: reward.id, count: debouncedCount }));
        }
    }, [dispatch, debouncedCount, project?.id, reward?.id]);

    useEffect(() => {
        setLocalCount(item?.count);
    }, [item?.count]);

    const decreaseCount = () => {
        setLocalCount(localCount - 1);
    };

    const increaseCount = () => {
        setLocalCount(localCount + 1);
    };

    const handleRemove = () => {
        dispatch(removeItemFromCart({ projectId: project.id, rewardId: reward.id })).then((cart) => {
            if (!cart?.items?.length && hideSupportButton) {
                const pathToProject = `/project/${project?.id}${subprojectId ? `?subproject=${subprojectId}` : ``}`;
                navigate(pathToProject);
            }
        });
    };

    return (
        <div className={[styles.item, !showChangeCountButtons ? styles.hideCountButtons : ''].join(' ')}>
            <span className={styles.rewardTitle}>{reward.title}</span>
            <span className={styles.rewardPrice}>{formatKrMoney(reward.price * localCount)}</span>
            <ButtonText className={styles.rewardRemove} onClick={handleRemove}>
                Fjern vare
            </ButtonText>
            {showChangeCountButtons && (
                <div className={styles.itemQuantity}>
                    <ChangeCountButtons
                        count={localCount}
                        minCount={1}
                        maxCount={maxCount}
                        increaseCount={increaseCount}
                        decreaseCount={decreaseCount}
                    />
                </div>
            )}
        </div>
    );
};
